/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_F2Inputs */

const en_mk_sol_agensi_f2 = /** @type {(inputs: Mk_Sol_Agensi_F2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing, Sales & CS, Finance & Ops`)
};

const id_mk_sol_agensi_f2 = /** @type {(inputs: Mk_Sol_Agensi_F2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing, Sales & CS, Finance & Ops`)
};

/**
* | output |
* | --- |
* | "Marketing, Sales & CS, Finance & Ops" |
*
* @param {Mk_Sol_Agensi_F2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_f2 = /** @type {((inputs?: Mk_Sol_Agensi_F2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_F2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_f2(inputs)
	return en_mk_sol_agensi_f2(inputs)
});